<script>
import HorizontalMenu from '@/components/general/HorizontalMenu'
import Breadcrumbs from '@/components/general/Breadcrumbs'
export default {
  components: {
    HorizontalMenu,
    Breadcrumbs
  },
  name: 'Users',
  provide () {
    return {
      getIsSsoAutoProvision: () => this.isSsoAutoProvision
    }
  },
  data () {
    return {
      selectedMenu: 0,
      isSsoAutoProvision: false,
      menuOptions: [
        { to: { name: 'business.admin.center.users.active' }, text: 'admin.center.users:menu.active', icon: 'mdi-account' },
        { to: { name: 'business.admin.center.users.removed' }, text: 'admin.center.users:menu.removed', icon: 'mdi-account-off' },
        { to: { name: 'business.admin.center.users.invites' }, text: 'admin.center.users:menu.invite', icon: 'mdi-email-plus-outline' }
      ]
    }
  },
  computed: {
    breadcrumbsPaths () {
      const path = [{ text: 'admin.center:menu.3:title', href: this.$route.path }]
      return path
    },
    visibleMenuOptions () {
      if (!this.isSsoAutoProvision) return this.menuOptions
      return this.menuOptions.filter((option) => option.to.name !== 'business.admin.center.users.invites')
    }
  },
  created () {
    this.loadSsoState()
  },
  methods: {
    loadSsoState () {
      this.$store.dispatch('attemptGetSsoConfig')
        .then(({ data }) => {
          this.isSsoAutoProvision = data.provision_mode === 'auto'
          this.redirectFromInvitesIfNeeded()
        })
        .catch((err) => {
          if (err.response && err.response.status === 404) {
            this.isSsoAutoProvision = false
          }
        })
    },
    redirectFromInvitesIfNeeded () {
      if (this.isSsoAutoProvision && this.$route.name === 'business.admin.center.users.invites') {
        this.$router.replace({ name: 'business.admin.center.users.active' })
      }
    }
  }
}
</script>
<template>
  <section class="users--container center-small">
    <div class="default-header">
      <breadcrumbs :items="breadcrumbsPaths"/>
      <h2>{{ $t('admin.center.users:title') }}</h2>
    </div>
    <horizontal-menu :options="visibleMenuOptions" v-model="selectedMenu"></horizontal-menu>
    <div class="users--body">
      <router-view></router-view>
    </div>
  </section>
</template>
<style lang="scss">
.users--container {
  .horizontal-menu--container {
    margin-bottom: 0px;
  }
  .users--body {
    margin-top: -44px;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1330px) {
  .users--container {
    margin-bottom: 70px !important;
  }
}
@media only screen and (max-width: 940px) {
  .users--container {
  .horizontal-menu--container {
    margin-bottom: 0px;
  }
  .users--body {
    margin-top: 40px;
  }
}
}
</style>
